import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { useLoginApi } from '@/api/auth';
import { PrimaryButton } from '@/components/common/Button/style';
import Field from '@/components/common/Field/Field';
import InputText from '@/components/common/Input/InputText/InputText';
import LineIcon from '@/components/Icon/lineIcon';
import { useAuthStore } from '@/store/authStore';
import { useModalStore } from '@/store/modalStore';

import * as S from './style';

const Auth = () => {
	const { t } = useTranslation();
	const { showModal } = useModalStore();
	const navigate = useNavigate();
	const [id, setId] = useState('');
	const [password, setPassword] = useState('');
	const { setName, setPk, setMemberType } = useAuthStore();

	const { mutateAsync: login } = useLoginApi();
	const handlePassword = (e: React.ChangeEvent<HTMLInputElement>) => {
		setPassword(e.target.value);
	};
	const handleId = (e: React.ChangeEvent<HTMLInputElement>) => {
		setId(e.target.value);
	};
	const handleLogin = async () => {
		try {
			const res = await login({
				member_id: id,
				member_password: password,
			});
			if (res.data.success) {
				setName(res.data.data.member_name);
				setPk(res.data.data.member_pk);
				setMemberType(res.data.data.member_type);
				navigate('/');
			} else {
				if (res.data.error.code === '86') {
					showModal(t('잠시 후 시도해 주세요.'));
				} else {
					showModal(t('아이디 또는 비밀번호를 확인해 주세요.'));
				}
			}
		} catch {
			showModal(t('로그인 중 오류가 발생했습니다.'));
		}
	};

	return (
		<S.Page>
			<S.Container>
				<S.PageHeader>
					<S.Eyebrow>Account</S.Eyebrow>
					<S.Title>{t('로그인')}</S.Title>
					<S.Subtitle>{t('auth.login.subtitle')}</S.Subtitle>
				</S.PageHeader>

				<S.FormCard>
					<S.FieldBox>
						<Field title="아이디" error="">
							<InputText placeholder="common.placeholders.loginId" input={handleId} value={id} />
						</Field>
						<Field title="비밀번호" error="">
							<InputText
								type="password"
								placeholder="common.placeholders.loginPassword"
								input={handlePassword}
								value={password}
								onKeyDown={(e) => e.key === 'Enter' && handleLogin()}
							/>
						</Field>
						<S.FormActions>
							<PrimaryButton type="button" onClick={handleLogin} disabled={!id || !password}>
								{t('로그인')}
							</PrimaryButton>
						</S.FormActions>
						<S.MenuBox>
							<S.MenuButton type="button" onClick={() => navigate('/auth/findid')}>
								{t('아이디 찾기')}
							</S.MenuButton>
							<LineIcon width="2" height="12" iconColor="#DEE2E6" />
							<S.MenuButton type="button" onClick={() => navigate('/auth/findpw')}>
								{t('비밀번호 찾기')}
							</S.MenuButton>
							<LineIcon width="2" height="12" iconColor="#DEE2E6" />
							<S.MenuButton type="button" onClick={() => navigate('/auth/signup')}>
								{t('회원가입')}
							</S.MenuButton>
						</S.MenuBox>
					</S.FieldBox>
				</S.FormCard>
			</S.Container>
		</S.Page>
	);
};

export default Auth;
